import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { CalendarIcon } from '@trello/nachos/icons/calendar';
import { usePopover } from '@trello/nachos/popover';
import type { QuickCardEditorTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { QuickCardEditorButton } from './QuickCardEditorButton';

interface AddCardToPlannerButtonProps {
  onClose: () => void;
}

export const AddCardToPlannerButton: FunctionComponent<
  AddCardToPlannerButtonProps
> = ({ onClose }) => {
  const { popoverProps, toggle, triggerRef } = usePopover();

  const onClick = useCallback(() => {
    toggle();
  }, [toggle]);

  return (
    <>
      <QuickCardEditorButton
        icon={<CalendarIcon size="small" />}
        onClick={onClick}
        ref={triggerRef}
        testId={getTestId<QuickCardEditorTestIds>(
          'quick-card-editor-add-card-to-planner',
        )}
        isSelected={popoverProps.isVisible}
      >
        <FormattedMessage
          id="templates.quick_card_editor.add-to-planner"
          defaultMessage="Add to Planner"
          description="Quick card editor Add to Planner card button"
        />
      </QuickCardEditorButton>

      {popoverProps.isVisible && (
        // TODO add in popover
        <div>Add card to planner popover</div>
      )}
    </>
  );
};
